import {StyleSheet, Text, View} from "react-native";
import {Color} from "@/lib/styles";
import {AggregateActivity} from "@/lib/types";
import Card from "@/lib/components/Card";
import {router} from "expo-router";
import {useQueryClient} from "@tanstack/react-query";
import AvatarBox from "@/lib/components/AvatarBox";
import Header from "@/lib/components/Header";
import Timestamp from "@/lib/components/Timestamp";

type Props = {
    activity: AggregateActivity,
}

export default function Activity({activity}: Props) {
    const queryClient = useQueryClient();

    function navigateTo() {
        // noinspection JSIgnoredPromiseFromCall
        queryClient.invalidateQueries();
        if (activity.event) {
            router.navigate(`/e/${activity.event.event_id}`);
        }
    }

    if (!activity.event) {
        return null;
    }

    const event = activity.event;

    return (
        <Card image_url={event.image_url}
              color={event.color}
              contrast_color={event.contrast_color}
              title={event.title}
              onPress={navigateTo}
        >
            {activity.activities.map((act, index) => (
                <View key={index}>
                    {act === "updated" && <Header title={"Eventet er oppdatert siden sist!"}/>}
                    {act === "temporal" && <Header title={"Eventet har nytt tidspunkt!"}/>}
                    {act === "location" && <Header title={"Eventet har byttet sted!"}/>}
                </View>
            ))}
            <View style={{flexDirection: "row", justifyContent: "flex-start", alignItems: "center", gap: 16}}>
                <Text style={styles.text}>Siste hendelse</Text>
                <Timestamp autoFade={false} relativeSince={true} start={new Date(activity.activity_at)}/>
            </View>
            {activity.attendees.length > 0 && <Header title={`Noen ber om invitasjon ( ${activity.solicitors.length} )`}/>}
            {activity.attendees.length > 0 && <Header title={`Dine venner deltar ( ${activity.attendees.length} )`}/>}
            {activity.followers.length > 0 && <Header title={`Dine venner følger ( ${activity.followers.length} )`}/>}
            {activity.followers.length + activity.attendees.length > 0 &&
                <AvatarBox avatars={activity.attendees.concat(activity.followers)} color={event.color}/>
            }
        </Card>
    )
}

export const styles = StyleSheet.create({
    container: {
        backgroundColor: Color.BackgroundContainer,
        borderRadius: 8,
        paddingHorizontal: 12,
        paddingVertical: 12,
    },
    text: {
        color: Color.PrimaryText,
        fontSize: 16,
    },
})